import React from 'react';
import NavBar from "../.././home/pageChild/NavBar";
import Footer from "../.././home/pageChild/Footer";
import End from "../.././home/pageChild/End";
import {
  Link
} from "react-router-dom";




class pageComplate extends React.Component{    
  render(){
       
      return ( 
        <div>
          <div className={`container-fluid custom_fluid`}>
            <div className="row custom_row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
              </div>
            </div>
            <h2 style={{ textAlign:"center", padding:"40px"}}>Đặt hàng thành công
                CẢM ƠN QUÝ KHÁCH ĐÃ ĐẶT HÀNG TRÊN WEBSITE CỦA CHÚNG TÔI!</h2>
            <p style={{fontSize:"20px", textAlign:"center", padding:"40px"}}>
                Nhân viên chăm sóc khách hàng của cửa hàng sẽ liên hệ với quý khách hàng khi đơn hàng #56494192 được xác nhận

                Quý khách hàng cũng có thể theo dõi đơn hàng bằng cách đăng nhập và theo dõi đơn hàng trên Web-site

                Cảm ơn quý khách hàng đã mua sắm trên mieumieushop
            </p>
            <div className="send_mail">
                <Link to="/">
                    <button type="button"> Ve Trang Chu</button>
                </Link>
            </div>
            <Footer />
            <End />
        </div>              
        </div>              
  
        )
      }
  }
export default pageComplate;